import { useSelector } from 'react-redux';

import { getItemCount } from 'cart/common/helpers';
import { currencyFormat } from 'common/helpers/numberHelper';
import { useLocalization } from 'redux/localization/utils/hooks';

const SubTotal = (props) => {
  const { cartOrOrder } = props;

  const { t } = useLocalization();
  const settings = useSelector((state) => state.setting.data);
  const { currency } = settings;
  const { subTotal } = cartOrOrder;
  const itemCount = getItemCount(cartOrOrder);

  return (
    <>
      <div className="c7-order-summary__item--subtotal">
        <div className="c7-order-summary__title">
          {t('checkout.general.subtotal')}
          <span>
            {itemCount}
            <span className="c7-sr-only">
              {itemCount === 1
                ? t('general.common.item')
                : t('general.common.items')}
            </span>
          </span>
        </div>
        <div className="c7-order-summary__value">
          {currencyFormat(subTotal, currency)}
        </div>
      </div>
    </>
  );
};

export default SubTotal;
